/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_DefaultVestingTemplateDto } from '../models/PagedResultDto_DefaultVestingTemplateDto';
import type { Wealthlane_AwardService_Dtos_DefaultVestingTemplate_CreateUpdatDefaultVestingTemplateDto } from '../models/Wealthlane_AwardService_Dtos_DefaultVestingTemplate_CreateUpdatDefaultVestingTemplateDto';
import type { Wealthlane_AwardService_Dtos_DefaultVestingTemplate_DefaultVestingTemplateDto } from '../models/Wealthlane_AwardService_Dtos_DefaultVestingTemplate_DefaultVestingTemplateDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DefaultVestingTemplateService {

    /**
     * @returns Wealthlane_AwardService_Dtos_DefaultVestingTemplate_DefaultVestingTemplateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDefaultVestingTemplateDefaultVestingTemplate(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_DefaultVestingTemplate_DefaultVestingTemplateDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/default-vesting-template/default-vesting-template',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_DefaultVestingTemplate_DefaultVestingTemplateDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppDefaultVestingTemplate(
        requestBody?: Wealthlane_AwardService_Dtos_DefaultVestingTemplate_CreateUpdatDefaultVestingTemplateDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_DefaultVestingTemplate_DefaultVestingTemplateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/default-vesting-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_DefaultVestingTemplateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDefaultVestingTemplate(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_DefaultVestingTemplateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/default-vesting-template',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_DefaultVestingTemplate_DefaultVestingTemplateDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppDefaultVestingTemplate(
        id: string,
        requestBody?: Wealthlane_AwardService_Dtos_DefaultVestingTemplate_CreateUpdatDefaultVestingTemplateDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_DefaultVestingTemplate_DefaultVestingTemplateDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/default-vesting-template/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppDefaultVestingTemplate(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/default-vesting-template/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_AwardService_Dtos_DefaultVestingTemplate_DefaultVestingTemplateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDefaultVestingTemplate1(
        id: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_DefaultVestingTemplate_DefaultVestingTemplateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/default-vesting-template/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
